import { deepClone } from "@mui/x-data-grid/utils/utils"
import { ID_MAP_EXTRA_FIELDS } from "../../../utils/utils";

export const getFormattedOverAndAboveBody = (requestBody:Record<string,any>):Record<string,any>=>{
    const newBody = deepClone(requestBody);

    newBody.schemeLocationBifurcationsList = [ID_MAP_EXTRA_FIELDS.location.reduce((acc:Record<string,string>,curr:string)=>{
        if(curr === 'schemeId')acc[curr] = requestBody.schemeId
        else acc[curr] = 'all';
        return acc;
    },{})]

    newBody.schemeOutletBifurcationsList = [ID_MAP_EXTRA_FIELDS.outlet.reduce((acc:Record<string,string> ,curr:string )=>{
        if(curr === 'schemeId') acc[curr] = requestBody.schemeId
        else if(curr === 'outletCode')acc[curr] = '';
        else acc[curr] = 'all';
        return acc;
    },{})]

    return newBody;
    
}